/**
 * @Author: 左建
 * @Date: 2022/6/17 14:29
 * @LastEditTime: 2022/6/17 14:29
 * @Description: 公共接口
*/
import { get, post } from "@/utils/request"

/**
 * 获取用户模块
 * @return {Promise<unknown>}
 */

export function getPersonRoute () {
    return post("/Manage/Platform/GetSystemModular")
}
